<template>
  <Row>
    <Col class="mt-1 ml-4" cols="11">
      <span class="d-block" v-for="line, index in lc.propagationInfo" :key="line[index]" v-text="line"/>
    </Col>
  </Row>
</template>

<script>
import { Row, Col } from '@locaweb/design-system-vue'

export default {
  name: 'PropagationInfo',
  components: {
    Row,
    Col
  },
  computed: {
    lc () {
      return this.$lc('domains.addDomain.domainStatus.domain_not_configured.modal')
    }
  }
}
</script>
